import { Ticket } from '@vendasta/support';

const VMF_INSTANCE = 'https://vendasta-support.zendesk.com/agent/tickets/';
const URL_REGEX = /(?:https?|ftp):\/\/[\n\S]+/g;
const badgeColor: Record<string, string> = {
  new: 'blue',
  open: 'grey',
  hold: 'yellow',
  pending: 'yellow',
  solved: 'green',
  closed: 'green',
};

export class TicketInfo {
  id: string;
  subject: string;
  description: string;
  status: string;
  requester: string;
  createdAt: string;
  channel: string;
  groupName: string;
  badgeColor: string;
  url: string;
  total: number;

  constructor(ticket: Ticket) {
    this.id = ticket.id.toString();
    this.subject = ticket.subject;
    this.description = this.formatDescription(ticket.description);
    this.status = ticket.status;
    this.requester = ticket.requester.name;
    this.createdAt = ticket.createdAt.toString().substring(0, 15);
    this.channel = ticket.via.channel;
    this.groupName = ticket.group.name;
    this.badgeColor = badgeColor[ticket.status] ? badgeColor[ticket.status] : 'grey';
    this.url = VMF_INSTANCE.concat(ticket.id.toString());
  }

  private formatDescription(text: string) {
    text = text.replace(URL_REGEX, '');
    return text.substring(0, 1200);
  }
}
